import React from 'react';

import { useSearchBox } from 'react-instantsearch';

import SearchInput from '~/pages/DiscoverPage/components/SearchInput/SearchInput';

const SmallSearch = () => {
  const { refine } = useSearchBox();

  const handleClear = () => {
    refine('');
  };

  return <SearchInput handleSearch={refine} handleClear={handleClear} />;
};

export default SmallSearch;
